import { render } from "./BranchTransactions.vue?vue&type=template&id=dcf5e402&scoped=true"
import script from "./BranchTransactions.vue?vue&type=script&lang=js"
export * from "./BranchTransactions.vue?vue&type=script&lang=js"

import "./BranchTransactions.vue?vue&type=style&index=0&id=dcf5e402&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf5e402"]])

export default __exports__